/**
 * created 18.08.2025
 */
/* eslint-disable */
import React, {PropsWithChildren, useEffect, useMemo, useState} from 'react';
import {useSearchParams} from 'react-router-dom';
import {type Course, getCourses, getFilteredCourse, getStartedCourses} from "../../api/courcesService";
import {useTranslation} from "react-i18next";
import CourserList from './CourserList';
import './RecommendedCourses.css';
import CoursesFilter from './CoursesFilter';
import {useAppState} from "../../store/useAppState";
import {smartNavigate} from "../../utils/smartNavigate";

type SearchParams = {
  filter: string;
  filterId: string;
};

export function AllCourses() {
  let [searchParams, setSearchParams] = useSearchParams({filter: ['recommended', 'trending', 'started'], filterId: 'all'});
  const {t} = useTranslation();
  const [courses, setCourses] = useState<Course[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const {isCoursesFilterOpen: isFilterOpen, setCoursesFilterOpen: setIsFilterOpen} = useAppState((state) => state);

  const filter = searchParams.get('filter');
  // const filterId = searchParams.get('filterId');

  useEffect(() => {
    const fetchData = async () => {
      try {
        setLoading(true);
        let coursesData: Course[] = [];
        // Fetch basic courses data
        if (['recommended', 'trending'].includes(filter || '')) {
          coursesData = await getFilteredCourse(filter || 'recommended');
        }
        if (filter === 'started') {
          coursesData = await getStartedCourses();
        }

        setCourses(coursesData);
      } catch (err) {
        setCourses([]);
        setError(t('product.courses.error'));
        console.error('Error fetching data:', err);
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [t]);

  const filtered = useMemo(() => {
    // const filterId = searchParams.get('filterId') || 'all';
    // if (filterId === 'completed') {
    //   return courses.filter(c => (c.totalLessons ?? 0) > 0 && (c.lessonsCompleted ?? 0) >= (c.totalLessons ?? 0));
    // }
    return courses;
  }, [courses]);

  const items = useMemo(() => filtered.map((c) => ({
    id: c.id,
    image: c?.featuredImage?.url,
    title: c.title,
    lessons: c.totalLessons ?? 0,
  })), [filtered]);

  return <>
    <div style={{display: 'flex', alignItems: 'center', justifyContent: 'space-between', margin: '8px 12px'}}>
    </div>

    {error ? (
      <div className="rc-empty">{error}</div>
    ) : (
      <CourserList items={items} loading={loading}
                   onItemClick={(course) => {smartNavigate(`/course/${course.id}`)}}/>
    )}

    <CoursesFilter
      open={isFilterOpen}
      initialState={{difficulty: 0, sort: 'newest'}}
      onClose={() => setIsFilterOpen(false)}
      onApply={(st) => {
        setSearchParams({filter: 'recommended'});
        setIsFilterOpen(false);
      }}
    />
  </>;
}
